// extracted by mini-css-extract-plugin
export default {"pageContainer":"SuccessBox_pageContainer__K+oZ5","formContainer":"SuccessBox_formContainer__BTBQy","heading":"SuccessBox_heading__qAdUx","text":"SuccessBox_text__uSR5V"};